export class Client {
  constructor(public clientId?: string, public campaignId?: string, public providerId?: string, public createTime?: number) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/client/client.model.ts